import { Component, OnInit, Inject } from '@angular/core';
import { MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ProcedureCodesService } from 'src/app/Services/ProcedureCodes/procedure-codes.service';
import { ToastrService } from 'ngx-toastr';
import { ISnomed } from 'src/app/models/IProcedureCodes';

@Component({
  selector: 'app-new-searchsnomedmaster',
  templateUrl: './new-searchsnomedmaster.component.html',
  styleUrls: ['./new-searchsnomedmaster.component.css']
})
export class NewSearchsnomedmasterComponent implements OnInit {

  SnomedMasterForm: FormGroup;
  dataSource = new MatTableDataSource();
  blue: string = '#BAFBC1';
  white: string = '#FFFFF';
  searchresults: string = "";
  displayedColumns: string[] = ['ConceptCode', 'ConceptName'];
  constructor(private formBuilder: FormBuilder, private procedureCodesService: ProcedureCodesService, private toastr: ToastrService,
    public dialogRef: MatDialogRef<NewSearchsnomedmasterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ISnomed, public dialog: MatDialog) { }

  ngOnInit() {
    this.SnomedMasterForm = this.formBuilder.group({
      Snomedlist: ['']
    });
  }

  onSearchSnomeddata() {
    var searchText = this.SnomedMasterForm.value.Snomedlist;
    this.searchMasterSnomedcodes(searchText);
  }

  public MasterSnomedList: ISnomed[];
  searchMasterSnomedcodes(searchText: any) {
    // var searchText = this.SnomedMasterForm.value.Snomedlist;
    if (searchText != null && searchText != undefined && searchText != '') {
      this.procedureCodesService.getSnomedBySearch(searchText).subscribe(
        results => {
          this.MasterSnomedList = results;
          if (results.length == 0) {
            this.searchresults = "No search results found.";
          }
          else {
            this.searchresults = "";
          }
          this.dataSource.data = this.MasterSnomedList;
        }, (err: any) => console.log(err));
    }
  }
  CancelSnomedMaster() {
    this.dialogRef.close(null);
  }

  onSnomedSearchCodes: ISnomed[] = [];

  searchReferraldropdownValue: string = "";
  async onSnomedSearch(val: any) {
    this.searchReferraldropdownValue = val;
    if (this.searchReferraldropdownValue.length > 2) {
      await this.procedureCodesService.getSnomedBySearch(this.searchReferraldropdownValue).subscribe(
        data => {
          this.onSnomedSearchCodes = data;
          if (data.length == 0) {
            this.searchresults = "No search results found.";
          }
          else {
            this.searchresults = "";
          }
          this.dataSource.data = this.onSnomedSearchCodes;
        }, (err: any) => console.log(err));

    }
    else {
      this.dataSource.data = [];

    }
  }

  selectedData(event: any) {
    let code = event.ConceptName + "##" + event.ConceptCode;
    this.dialogRef.close(code);
  }
}
